export default "__VITE_ASSET__6ad53472__"